import { goToLogin } from '../../router';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:5041';

const presupuestoService = (() => {
  const axios = require('axios');

  const instance = axios.create({
    baseURL: API_URL,
    withCredentials: true,
  });

  instance.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
        goToLogin();
      }
      return Promise.reject(error);
    }
  );

  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("jwt-token");
      if (token) {
        config.headers["Authorization"] = "Bearer " + token;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  const createPresupuesto = async (presupuestoData) => {
    try {
      const response = await instance.post(
        "/Presupuesto/create-presupuesto",
        presupuestoData
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error al crear presupuesto:",
        error.response?.data || error.message
      );
      throw {
        success: false,
        error: error.response?.data || "Error al crear el presupuesto",
      };
    }
  };

  const getPresupuestos = async () => {
    try {
      const response = await instance.get(
        "/Presupuesto/get-presupuestos-by-tenant"
      );
      return response.data || [];
    } catch (error) {
      console.error(
        "Error al obtener presupuestos:",
        error.response?.data || error.message
      );
      throw {
        success: false,
        error: error.response?.data || "Error al obtener presupuestos",
      };
    }
  };

  const getPresupuestoById = async (id) => {
    try {
      const response = await instance.get(`/Presupuesto/${id}`);
      return response.data;
    } catch (error) {
      console.error(
        "Error al obtener presupuesto:",
        error.response?.data || error.message
      );
      throw {
        success: false,
        error: error.response?.data || "Error al obtener el presupuesto",
      };
    }
  };

  const updatePresupuesto = async (id, presupuestoData) => {
    try {
      const response = await instance.put(
        `/Presupuesto/${id}`,
        presupuestoData
      );
      if (response.status === 204) {
        return { success: true };
      }
      return response.data;
    } catch (error) {
      console.error(
        "Error al actualizar presupuesto:",
        error.response?.data || error.message
      );
      throw {
        success: false,
        error: error.response?.data || "Error al actualizar el presupuesto",
      };
    }
  };

  const deletePresupuesto = async (id) => {
    try {
      const response = await instance.delete(`/Presupuesto/${id}`);
      if (response.status === 204) {
        return { success: true };
      }
      return response.data;
    } catch (error) {
      console.error(
        "Error al eliminar presupuesto:",
        error.response?.data || error.message
      );
      throw {
        success: false,
        error: error.response?.data || "Error al eliminar el presupuesto",
      };
    }
  };

  const getAllPresupuestos = async () => {
    try {
      const response = await instance.get("/Presupuesto/get-all");
      return response.data || [];
    } catch (error) {
      console.error(
        "Error al obtener todos los presupuestos:",
        error.response?.data || error.message
      );
      throw {
        success: false,
        error:
          error.response?.data || "Error al obtener todos los presupuestos",
      };
    }
  };

  const getByCodigo = async (codigo) => {
    try {
      const response = await instance.get(`/codigo/${codigo}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching presupuesto by codigo:", error);
      throw error;
    }
  };


  return {
    createPresupuesto,
    getPresupuestos,
    getPresupuestoById,
    updatePresupuesto,
    deletePresupuesto,
    getAllPresupuestos,
    getByCodigo,
  };
})();

export default presupuestoService;
